<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
    </page-main>
    <DetailDialog
      :visible.sync="detailDialogOptions.visible"
      :title="
        $l('INDEX.dialog_title_order_proofing_view') || '样品要求信息详情'
      "
      :orderProofingCode="detailDialogOptions.code"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import DetailDialog from '../detail/dialog.vue'
export default {
  components: { PageHeader, PageMain, DetailDialog },
  mixins: [BaseTable],
  props: { orderCode: { type: String, default: '' } },
  data() {
    return {
      detailDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .pendingOrderProofingListApi({
          orderCode: this.orderCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ orderProofingCode }) {
      this.detailDialogOptions = {
        visible: true,
        code: orderProofingCode,
      }
    },
  },
}
</script>
